export const ACCEPTABLE_TERMS = [12, 18, 24]

export const MINIMUM_REQUESTABLE_LOAN_AMOUNT = 1000.0

export const MAXIMUM_REQUESTABLE_LOAN_AMOUNT = 1500000.0 // 250000.0
